import {
  HOUR,
  messageFromError,
  type TeamGetInput,
  type TeamGetSuccess,
  type TeamId,
  type TeamMemberData,
} from '@terros/common'
import { useQueries } from '@tanstack/react-query'
import { teamKey } from '../keys'
import { useServerRequest } from '../api'

export type TeamMembersState = {
  membersByTeamId: Map<TeamId, TeamMemberData[]>
  loadingTeamIds: Set<TeamId>
  error?: string
}

export function useTeamMembers(teamIds: TeamId[], enabled = true): TeamMembersState {
  const serverRequest = useServerRequest<TeamGetInput, TeamGetSuccess>('/team/get')

  return useQueries({
    queries: teamIds.map((teamId) => ({
      queryKey: teamKey(teamId),
      queryFn: () => serverRequest({ teamId }),
      staleTime: HOUR,
      gcTime: HOUR,
      retry: false,
      enabled,
    })),
    combine: (results) => {
      const membersByTeamId = new Map<TeamId, TeamMemberData[]>()
      const loadingTeamIds = new Set<TeamId>()
      results.forEach((result, index) => {
        const teamId = teamIds[index]
        if (result.isLoading) loadingTeamIds.add(teamId)
        if (result.data) membersByTeamId.set(teamId, result.data.members)
      })
      return {
        membersByTeamId,
        loadingTeamIds,
        error: messageFromError(results.find((result) => result.error)?.error),
      }
    },
  })
}
